import {
	ADD_ATTRIBUTE_TO_ATTRIBUTE_GROUP_SAGA,
	CLEAR_ATTRIBUTE_STATE,
	EDIT_ATTRIBUTE_GROUP_SAGA,
	FETCH_ATTRIBUTES_AND_PRODUCTS_SAGA,
	FETCH_ATTRIBUTE_GROUP_DETAIL_SAGA,
	FETCH_ATTRIBUTE_GROUP_SAGA,
	FETCH_ATTRIBUTE_GROUP_PRODUCTS_SAGA,
	UPDATE_ATTRIBUTE_GROUP_SAGA,
	FETCH_INFINITY_SCROLL_ATTRIBUTE_GROUP_SAGA,
	CLEAR_ATTRIBUTE_GROUP_STATE
} from "./types/types";

export const fetchAttributesAndProducts = (payload: any): any => (
	{ type: FETCH_ATTRIBUTES_AND_PRODUCTS_SAGA, payload }
);

export const addAttributeToAttributeGroup = (payload: any): any => (
	{ type: ADD_ATTRIBUTE_TO_ATTRIBUTE_GROUP_SAGA, payload }
);

export const fetchAttributeGroup = (menu_id: string, page: number = 1, search: string = ""): any => (
	{ type: FETCH_ATTRIBUTE_GROUP_SAGA, payload: { menu_id, search, page } }
);

export const fetchInfinityScrollAttributeGroup = (menu_id: string, page: number = 1): any => (
	{ type: FETCH_INFINITY_SCROLL_ATTRIBUTE_GROUP_SAGA, payload: { menu_id, page } }
);

export const clearAttributeGroup = (): any => ({
	type: CLEAR_ATTRIBUTE_GROUP_STATE
});

export const fetchAttributeGroupDetail = (payload: any): any => (
	{ type: FETCH_ATTRIBUTE_GROUP_DETAIL_SAGA, payload }
);

export const clearAttributeState = (): any => (
	{ type: CLEAR_ATTRIBUTE_STATE }
);

export const editAttributeGroup = (menu_id: string, body: any): any => (
	{ type: EDIT_ATTRIBUTE_GROUP_SAGA, payload: { menu_id, body } }
);

export const fetchAttributeGroupProducts = (payload: any): any => (
	{ type: FETCH_ATTRIBUTE_GROUP_PRODUCTS_SAGA, payload }
);

export const updateAttributeGroup = (payload: any): any => (
	{ type: UPDATE_ATTRIBUTE_GROUP_SAGA, payload }
);
